module.exports = __webpack_public_path__ + "img/1440.21e8d26a.jpg";